(function ($) {
    var serviceUrl = "https://api.reciteme.com/asset/js?key=";
    var serviceKey = "1bc7b5c004c4546e9be42887b4f57d3ae9e7c121";
    var options = {};  // Options can be added as needed
    var autoLoad = false;
    var enableFragment = "#reciteEnable";
    var loaded = [],
        frag = !1;
    window.location.hash === enableFragment && (frag = !0);

    function loadScript(c, b) {
        var a = document.createElement("script");
        a.readyState ? a.onreadystatechange = function() {
            if ("loaded" == a.readyState || "complete" == a.readyState) a.onreadystatechange = null, void 0 != b && b()
        } : void 0 != b && (a.onload = function() {
            b()
        });
        a.src = c;
        document.getElementsByTagName("head")[0].appendChild(a)
    }

    function _rc(c) {
        c += "=";
        for (var b = document.cookie.split(";"), a = 0; a < b.length; a++) {
            for (var d = b[a];
                " " == d.charAt(0);) d = d.substring(1, d.length);
            if (0 == d.indexOf(c)) return d.substring(c.length, d.length)
        }
        return null
    }

    function loadService(c) {
        for (var b = serviceUrl + serviceKey, a = 0; a < loaded.length; a++)
            if (loaded[a] == b) return;
        loaded.push(b);
        loadScript(serviceUrl + serviceKey, function() {
            "function" === typeof _reciteLoaded && _reciteLoaded();
            "function" == typeof c && c();
            Recite.load(options);
            Recite.Event.subscribe("Recite:load", function() {
                Recite.enable()
            })
        })
    }
    "true" == _rc("Recite.Persist") && loadService();
    (autoLoad && "false" != _rc("Recite.Persist") || frag) && loadService();

    if ($().isWelshPage()) {
        // we have to load immediately for Welsh, as we may need to do translations
        loadScript(serviceUrl + serviceKey, _reciteLoadedWelsh);
    } else {
        // for English, we load on demand
        $(".utility-links-recite-me-link").on('click', function() {
            loadService();
        });
    }

    function _reciteLoaded() {
        Recite.Event.subscribe('Controls:loaded', function () {
            $('ul#recite-languages li[data-language="cy"]').remove();
            $('ul#recite-languages li[data-language="en-GB"]').remove();
            $('ul#recite-languages li[data-language="en-US"]').remove();
        });
    }

    function _reciteLoadedWelsh() {
        $(".utility-links-recite-me-link").on('click', function() {
            if (!Recite.isEnabled()) {
                Recite.load(options);
                Recite.Event.subscribe("Recite:load", function() {
                    Recite.enable()
                })
            }
            return false;
        });

        _reciteLoaded();

        $('.machine-translate-to-welsh').each( function () {
            $(this).attr('lang', 'en');
            Recite.Language.Translate.translate(this, 'cy');
        });
    }

})(jQuery);
